/** 区号国家/地区名称 - 繁体中文 */
export default {
  areaCodes: {
  "1": "中國",
  "2": "中國香港",
  "3": "中國臺灣",
  "4": "美國",
  "7": "中國澳門",
  "8": "安道爾共和國",
  "9": "阿拉伯聯合酋長國",
  "10": "阿富汗",
  "11": "安提瓜和巴布達",
  "12": "安圭拉島",
  "13": "阿爾巴尼亞",
  "14": "亞美尼亞",
  "15": "阿森松",
  "16": "安哥拉",
  "17": "阿根廷",
  "18": "奧地利",
  "19": "澳大利亞",
  "20": "阿塞拜疆",
  "21": "巴巴多斯",
  "22": "孟加拉國",
  "23": "比利時",
  "24": "布基納法索",
  "25": "保加利亞",
  "26": "巴林",
  "27": "布隆迪",
  "28": "貝寧",
  "29": "巴勒斯坦",
  "30": "百慕大群島",
  "31": "文萊",
  "32": "玻利維亞",
  "33": "巴西",
  "34": "巴哈馬",
  "35": "博茨瓦納",
  "36": "白俄羅斯",
  "37": "伯利茲",
  "38": "加拿大",
  "39": "開曼群島",
  "40": "中非共和國",
  "41": "剛果",
  "42": "瑞士",
  "43": "庫克群島",
  "44": "智利",
  "45": "喀麥隆",
  "46": "哥倫比亞",
  "47": "哥斯達黎加",
  "48": "古巴",
  "49": "塞浦路斯",
  "50": "捷克",
  "51": "德國",
  "52": "吉布提",
  "53": "丹麥",
  "54": "多米尼加共和國",
  "55": "阿爾及利亞",
  "56": "厄瓜多爾",
  "57": "愛沙尼亞",
  "58": "埃及",
  "59": "西班牙",
  "60": "埃塞俄比亞",
  "61": "芬蘭",
  "62": "斐濟",
  "63": "法國",
  "64": "加蓬",
  "65": "英國",
  "66": "格林納達",
  "67": "格魯吉亞",
  "68": "法屬圭亞那",
  "69": "加納",
  "70": "直布羅陀",
  "71": "岡比亞",
  "72": "幾內亞",
  "73": "希臘",
  "74": "危地馬拉",
  "75": "關島",
  "76": "圭亞那",
  "77": "洪都拉斯",
  "78": "海地",
  "79": "匈牙利",
  "80": "印度尼西亞",
  "81": "愛爾蘭",
  "82": "以色列",
  "83": "印度",
  "84": "伊拉克",
  "85": "伊朗",
  "86": "冰島",
  "87": "意大利",
  "88": "科特迪瓦",
  "89": "牙買加",
  "90": "約旦",
  "91": "日本",
  "92": "肯尼亞",
  "93": "吉爾吉斯坦",
  "94": "柬埔寨",
  "95": "朝鮮",
  "96": "韓國",
  "97": "科特迪瓦共和國",
  "98": "科威特",
  "99": "哈薩克斯坦",
  "100": "老撾",
  "101": "黎巴嫩",
  "102": "聖盧西亞",
  "103": "列支敦士登",
  "104": "斯裏蘭卡",
  "105": "利比裏亞",
  "106": "萊索托",
  "107": "立陶宛",
  "108": "盧森堡",
  "109": "拉脫維亞",
  "110": "利比亞",
  "111": "摩洛哥",
  "112": "摩納哥",
  "113": "摩爾多瓦",
  "114": "馬達加斯加",
  "115": "馬裏",
  "116": "緬甸",
  "117": "蒙古",
  "118": "蒙特塞拉特島",
  "119": "馬耳他",
  "120": "馬裏亞那群島",
  "121": "馬提尼克",
  "122": "毛裏求斯",
  "123": "馬爾代夫",
  "124": "馬拉維",
  "125": "墨西哥",
  "126": "馬來西亞",
  "127": "莫桑比克",
  "128": "納米比亞",
  "129": "尼日爾",
  "130": "尼日利亞",
  "131": "尼加拉瓜",
  "132": "荷蘭",
  "133": "挪威",
  "134": "尼泊爾",
  "135": "荷屬安的列斯",
  "136": "瑙魯",
  "137": "新西蘭",
  "138": "阿曼",
  "139": "巴拿馬",
  "140": "秘魯",
  "141": "法屬玻利尼西亞",
  "142": "巴布亞新幾內亞",
  "143": "菲律賓",
  "144": "巴基斯坦",
  "145": "波蘭",
  "146": "波多黎各",
  "147": "葡萄牙",
  "148": "巴拉圭",
  "149": "卡塔爾",
  "150": "留尼旺",
  "151": "羅馬尼亞",
  "152": "俄羅斯",
  "153": "沙特阿拉伯",
  "154": "所羅門群島",
  "155": "塞舌爾",
  "156": "蘇丹",
  "157": "瑞典",
  "158": "新加坡",
  "159": "斯洛文尼亞",
  "160": "斯洛伐克",
  "161": "塞拉利昂",
  "162": "聖馬力諾",
  "163": "東薩摩亞(美)",
  "164": "西薩摩亞",
  "165": "塞內加爾",
  "166": "索馬裏",
  "167": "蘇裏南",
  "168": "聖多美和普林西比",
  "169": "薩爾瓦多",
  "170": "敘利亞",
  "171": "斯威士蘭",
  "172": "乍得",
  "173": "多哥",
  "174": "泰國",
  "175": "塔吉克斯坦",
  "176": "土庫曼斯坦",
  "177": "突尼斯",
  "178": "湯加",
  "179": "土耳其",
  "180": "特立尼達和多巴哥",
  "182": "坦桑尼亞",
  "183": "烏克蘭",
  "184": "烏幹達",
  "186": "烏拉圭",
  "187": "烏茲別克斯坦",
  "188": "聖文森特島",
  "189": "委內瑞拉",
  "190": "越南",
  "191": "也門",
  "192": "南斯拉夫",
  "193": "南非",
  "194": "贊比亞",
  "195": "紮伊爾",
  "196": "津巴布韋"
}
};
